import { Grid, Typography } from "@mui/material";
import { useInsideLayout } from "layouts/common/inside/InsideLayoutContext";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const Home: React.FC = () => {
    const layout = useInsideLayout();
    const { t } = useTranslation("core");

    useEffect(() => {
        layout.changeSubHeaderText(t("Home.SubHeaderText"));
        layout.setMenuOpened(true);
    }, []);


    return (
        <Grid container justifyContent="center" alignItems="center" direction="column" width="100%" spacing={2}>
            <Grid size="grow">
                <Typography variant="h1" noWrap>{t("Home.Title")}</Typography>
            </Grid>

            <Grid size="grow">
                <Typography variant="h3" noWrap>{t("Home.Message")}</Typography>
            </Grid>

            <Grid size="grow">
                <Grid container justifyContent="center" alignItems="center">
                    <Grid>
                        <img src="/img/app/Foundation-Settings.png" width="100%" />
                    </Grid>
                </Grid>
            </Grid>

        </Grid>
    );
};
